import {
  inventoryItemIdFormat,
  locationIdFormat,
  packingTemplateIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import { packingMode } from "@redotech/redo-model/inventory/packing-mode";
import * as z from "zod/v4";

export const lookupProductByBarcode = {
  name: "lookupProductByBarcode" as const,
  input: z.object({
    barcode: z.string().max(255),
    locationId: locationIdFormat.schema.optional(),
    enforceLicensePlateScan: z.boolean().optional(),
  }),
  output: z.object({
    products: z.array(
      z.object({
        id: productIdFormat.schema,
        title: z.string(),
        imageUrl: z.string().nullish(),
        sku: z.string().nullish(),
        barcode: z.string().nullish(),
        currentInventory: z.number().nullable(),
        packingTemplateId: packingTemplateIdFormat.schema.nullable(),
        unitsPerBox: z.number().nullable(),
        packingMode: z.enum(packingMode),
        trackLotFulfillment: z.boolean(),
      }),
    ),
    inventoryItem: z
      .object({
        inventoryItemId: inventoryItemIdFormat.schema,
        kind: z.string().nullable(),
        grade: z.string().nullable(),
        disposition: z.string().nullable(),
        returnId: z.string().nullable(),
        product: z
          .object({
            id: productIdFormat.schema,
            title: z.string(),
            sku: z.string().nullable(),
            imageUrl: z.string().nullable(),
          })
          .nullable(),
      })
      .nullable(),
  }),
};
